import { useAuth } from '../lib/auth';
import { PasswordForm } from '../components/PasswordForm';

/** First sign-in with a temporary password: the person picks their own before going further. */
export function SetPassword() {
  const { me, logout } = useAuth();
  return (
    <div className="flex min-h-full items-center justify-center px-4 py-12">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-800">
        <h1 className="text-xl font-semibold">Welcome{me ? `, ${me.name.split(' ')[0]}` : ''}! 👋</h1>
        <p className="mt-1 mb-6 text-slate-600 dark:text-slate-400">
          Before you start, please choose your own password. You’ll use it every time you sign in.
        </p>
        <PasswordForm currentLabel="Temporary password (the one you just used)" submitLabel="Save and continue" />
        <button onClick={logout} className="mt-4 text-sm text-slate-500 hover:underline">Sign out</button>
      </div>
    </div>
  );
}
